import { Controller, PlayerDirection } from "./Controller";
import { Signal0 } from "@/js/util/event/Signal0";
import { Value } from "@/js/util/Value";
import { Engine } from "@/game/libs/engine/engine";
import { SignalConnection } from "@/js/util/event/SignalConnection";
import { clamp } from "@/js/math/FMath";

export default class ControllerMobile implements Controller {
  onJump: Signal0;
  onFace: Value<PlayerDirection>;

  constructor() {
    this.onJump = new Signal0();
    this.onFace = new Value<PlayerDirection>(PlayerDirection.FACE_UP);
    this._downY = 0;
    this._lastPosition = this.onFace._;

    this._pointerDownFn = Engine.pointer.down.connect(e => {
      this._isPointerDown = true;
      this._downY = e.data.global.y;
      this._lastPosition = this.onFace._;
      this.screenPos(e.data.global.x, e.data.global.y);
    });
    this._pointerUpFn = Engine.pointer.up.connect(e => {
      if (!this._isPointerDown) return;
      this.onJump.emit();
      this._isPointerDown = false;
    });
    this._pointerMoveFn = Engine.pointer.move.connect(e => {
      if (!this._isPointerDown) return;
      this.screenPos(e.data.global.x, e.data.global.y);
    });
  }

  reset(): void {
    this.onFace._ = PlayerDirection.FACE_UP;
  }

  screenPos(x: number, y: number): void {
    var xP = clamp(x / Engine.renderer.width, 0, 1);

    var distY = this._downY - y;
    if (distY > ControllerMobile.SWIPE_Y_DIST) {
      this.onFace._ = PlayerDirection.FACE_UP;
      this._isPointerDown = false;
    } else {
      if (distY < 0) {
        this._downY = y;
      }
      this.moveCharacter(xP, y);
    }
  }

  moveCharacter(xP: number, y: number): void {
    if (xP > 0.8) {
      this.onFace._ = PlayerDirection.FACE_RIGHT;
    } else if (xP > 0.6) {
      this.onFace._ = PlayerDirection.FACE_SLIGHT_RIGHT;
    } else if (xP > 0.4) {
      this.onFace._ = PlayerDirection.FACE_DOWN;
    } else if (xP > 0.2) {
      this.onFace._ = PlayerDirection.FACE_SLIGHT_LEFT;
    } else if (xP > 0.0) {
      this.onFace._ = PlayerDirection.FACE_LEFT;
    }
    if (this._lastPosition != this.onFace._) {
      this._downY = y;
      this._lastPosition = this.onFace._;
    }
  }

  dispose() {
    this._pointerDownFn.dispose();
    this._pointerUpFn.dispose();
    this._pointerMoveFn.dispose();
  }

  private _isPointerDown: boolean = false;
  private _pointerDownFn: SignalConnection;
  private _pointerUpFn: SignalConnection;
  private _pointerMoveFn: SignalConnection;
  private _downY: number;
  private _lastPosition: PlayerDirection;
  private static SWIPE_Y_DIST = 100;
}
